import React from "react";

function formatValue(value) {
  if (Array.isArray(value)) {
    return value.join(", ");
  }

  return value;
}

function EsimInfoSections({
  sections,
  className = "",
  sectionClassName = "",
  gridClassName = "sm:grid-cols-1",
}) {
  if (!Array.isArray(sections) || sections.length === 0) {
    return null;
  }

  return (
    <div className={`flex flex-col gap-4 ${className}`}>
      {sections.map((section) => (
        <section
          key={section.title}
          className={`rounded-[24px] border border-[#D8E5FF] bg-white/90 p-5 shadow-[0px_18px_45px_rgba(15,23,42,0.06)] ${sectionClassName}`}
        >
          <h3 className="text-base font-bold text-[#1E305A] sm:text-lg">
            {section.title}
          </h3>

          <div className={`mt-4 grid gap-4 ${gridClassName}`}>
            {section.items.map((item) => (
              <div
                key={`${section.title}-${item.label}`}
                className="rounded-[18px] bg-[#F5F8FF] px-4 py-3"
              >
                <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-500">
                  {item.label}
                </p>
                <p className="mt-2 text-sm leading-relaxed text-[#1E305A] sm:text-[15px]">
                  {formatValue(item.value)}
                </p>
              </div>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}

export default EsimInfoSections;
